import type { SliceTemplateProps } from '@yoweb/prismic-slicemachine/slices/slicesTypes';
import CardCarouselSectionSlice, {
  CardCarouselSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/CardCarouselSectionSlice';
import ChatMessageSlice, {
  ChatMessageSliceType,
} from '@yoweb/prismic-slicemachine/slices/ChatMessageSlice';
import ColoredCtaSectionSlice, {
  ColoredCtaSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/ColoredCtaSectionSlice';
import AppDownloadCtaSectionSlice, {
  AppDownloadCtaSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/AppDownloadCtaSectionSlice';
import CornerCardSectionSlice, {
  CornerCardSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/CornerCardSectionSlice';
import DividerSlice, { DividerSliceType } from '@yoweb/prismic-slicemachine/slices/DividerSlice';
import ExplanationSectionSlice, {
  ExplanationSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/ExplanationSectionSlice';
import FaqSlice, { FaqSliceType } from '@yoweb/prismic-slicemachine/slices/FaqSlice';
import MediaHeaderSlice, {
  MediaHeaderSliceType,
} from '@yoweb/prismic-slicemachine/slices/MediaHeaderSlice';
import SeoSlice, { SeoSliceType } from '@yoweb/prismic-slicemachine/slices/SeoSlice';
import VerticalScrollCarouselSlice, {
  VerticalScrollCarouselSliceType,
} from '@yoweb/prismic-slicemachine/slices/VerticalScrollCarouselSlice';
import type { ChatMessageSliceResponse } from '@yoweb/prismic-slicemachine/slices/ChatMessageSlice/ChatMessageSliceTypes';
import { ErrorDisplay } from '@yoweb/ui/components/form';

export const HowItWorksTemplate = ({ slice, slices }: SliceTemplateProps) => {
  switch (slice.slice_type) {
    case SeoSliceType:
      return <SeoSlice slice={slice} />;

    case MediaHeaderSliceType:
      return <MediaHeaderSlice data-testid="how-it-works-hero" slice={slice} />;

    case FaqSliceType:
      return <FaqSlice background="evening" slice={slice} />;

    case DividerSliceType:
      return <DividerSlice slice={slice} />;

    case ExplanationSectionSliceType:
      return <ExplanationSectionSlice slice={slice} pt={{ _: 'large3', md: 'large2', lg: 104 }} />;

    case CornerCardSectionSliceType:
      return <CornerCardSectionSlice slice={slice} />;

    case VerticalScrollCarouselSliceType:
      return <VerticalScrollCarouselSlice slice={slice} />;

    case ColoredCtaSectionSliceType:
      return <ColoredCtaSectionSlice slice={slice} pt={{ _: 'large3', lg: 100 }} />;

    case AppDownloadCtaSectionSliceType:
      return <AppDownloadCtaSectionSlice slice={slice} pt={{ _: 'large3', lg: 100 }} />;

    case CardCarouselSectionSliceType: {
      const chatMessageSlice = slices.find(
        (_slice) => _slice.slice_type === ChatMessageSliceType,
      ) as ChatMessageSliceResponse | undefined;
      return (
        <CardCarouselSectionSlice
          slice={slice}
          id={`chat-reveal-carousel-section-${slice.primary.title
            .toLowerCase()
            .split(' ')
            .join('-')}`}
          background="base050"
        >
          {chatMessageSlice
            ? slice.items.map((item) => (
                <ChatMessageSlice
                  key={item.label}
                  slice={chatMessageSlice}
                  cardCarouselItem={item}
                />
              ))
            : // eslint-disable-next-line react/jsx-no-literals
              [
                <ErrorDisplay key="missing" title={`Prismic CMS error occurred.`} withBorder>
                  {
                    // eslint-disable-next-line react/jsx-no-literals
                    'CardCarouselSectionSlice requires ChatMessageSlice. Please add data to the ChatMessageSlice.'
                  }
                </ErrorDisplay>,
              ]}
        </CardCarouselSectionSlice>
      );
    }
    default:
      return null;
  }
};
